import { types } from '../types/types';

/**
 * EX-607: cuántos cobros con datáfono quedan pendientes de revisión manual.
 *
 * Vive en Redux y no en la propia pantalla porque quien tiene que enterarse es el menú lateral,
 * que es hermano de la página: el negocio no puede depender de acordarse de entrar a mirar.
 * Solo el contador, no el listado: la pantalla lee los cobros con sus filtros y el menú no los
 * necesita.
 */
const initialState = {
    pendientes: 0
}

export const cobrosRevisionReducer = ( state = initialState, action ) => {
    switch (action.type) {

        case types.cobrosRevisionPendientesSet:
            return {
                ...state,
                pendientes: action.payload
            }

        default:
            return state;
    }
}
